import React from 'react';
import { Dialog } from '@headlessui/react';
import { Button } from './Button';

export default function ConfirmDialog({ open, title, description, confirmLabel, cancelLabel = 'Abbrechen', onConfirm, onClose, busy = false, danger = false, confirmDisabled = false }: {
  open: boolean; title: string; description: string; confirmLabel: string;
  onConfirm: () => void; onClose: () => void; busy?: boolean; danger?: boolean; cancelLabel?: string; confirmDisabled?: boolean;
}) {
  return <Dialog open={open} onClose={() => { if (!busy) onClose(); }} className="relative z-50">
    <div className="fixed inset-0 bg-gray-900/50" aria-hidden="true" />
    <div className="fixed inset-0 overflow-y-auto p-4"><div className="flex min-h-full items-center justify-center">
      <Dialog.Panel className="w-full max-w-md rounded-xl bg-white p-6 shadow-xl">
        <Dialog.Title className="text-lg font-semibold text-gray-900">{title}</Dialog.Title>
        <Dialog.Description className="mt-2 text-sm leading-6 text-gray-600">{description}</Dialog.Description>
        <div className="mt-6 flex flex-wrap justify-end gap-3">
          <Button variant="outline" onClick={onClose} disabled={busy}>{cancelLabel}</Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm} loading={busy} disabled={confirmDisabled}>{confirmLabel}</Button>
        </div>
      </Dialog.Panel>
    </div></div>
  </Dialog>;
}
